import * as React from 'react';

import 'font-awesome/css/font-awesome.min.css';

enum IconType {
  ChevronLeft = 'fa-angle-left',
  Close = 'fa-times',
  Edit = 'fa-pencil-square-o',
  Info = 'fa-info-circle',
  Question = 'fa-question-circle',
  Reset = 'fa-repeat',
  Search = 'fa-search',
  Warning = 'fa-exclamation-triangle'
}

interface Props {
  iconType: IconType;
  fontSize?: string;
  color?: string;
  onClick?: () => void;
}

const Icon: React.FunctionComponent<Props> = props => {
  return (
    <div
      onClick={props.onClick}
      className={'fa ' + props.iconType}
      style={{ fontSize: props.fontSize, color: props.color }}
    />
  );
};

export { Icon, IconType };
